import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fakeSessionLogIn } from "../../app/store/auth/authActions";
import { USER_TOKEN } from "../../app/store/auth/authMiddleware";

export default function useFakeSession() {
  const dispatch = useDispatch();

  const validSessionToken = (): boolean => {
    const userToken = sessionStorage.getItem(USER_TOKEN);
    if (userToken) {
      const parseUserToken = JSON.parse(userToken);
      if (parseUserToken.sessionToken) {
        const tokenTimeValid = new Date(parseUserToken.tokenValidTo).getTime();
        const actualTime = new Date().getTime();
        if (actualTime <= tokenTimeValid) {
          return false;
        }
      }
    }
    return true;
  };

  useEffect(
    () => {
      if (validSessionToken()) {
        dispatch(fakeSessionLogIn());
      }
    }, //eslint-disable-next-line
    []
  );
}
